import {FC} from 'react'
import { AboutCard } from './AboutCard.component'

export interface MobileCardHolderProps {
    
}

export const MobileCardHolder: FC<MobileCardHolderProps> = (props) => {

    return(
        <>
            <AboutCard
                num={1}
                title='Who we are'
                description='You get a 2-week free trial to kick the Smarty tries. We want you to.'
            />
            <AboutCard
                num={2}
                title='What do we do'
                description='We give you a free course that guides you throught the process.'
            />
            <AboutCard
                num={3}
                title='How do we help'
                description='Use our multimedia lectures, videos, and coaching sessions.'
            />
            <AboutCard
                num={4}
                title='Create success story'
                description='With access to online learning resources anyone can transform.'
            />
        </>
    )
}